var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonthlyProfitsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M23.8335 14.0833H17.3335V5.41667C17.3335 4.21958 18.3031 3.25 19.5002 3.25H21.6668C22.8639 3.25 23.8335 4.21958 23.8335 5.41667V14.0833Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 14.082H23.8335V20.582C23.8335 21.7791 22.8639 22.7487 21.6668 22.7487H19.5002C18.3031 22.7487 17.3335 21.7791 17.3335 20.582V14.082Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.25 17.3346H9.75V10.8346C9.75 9.63755 10.7196 8.66797 11.9167 8.66797H14.0833C15.2804 8.66797 16.25 9.63755 16.25 10.8346V17.3346Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 17.332H16.25V20.582C16.25 21.7791 15.2804 22.7487 14.0833 22.7487H11.9167C10.7196 22.7487 9.75 21.7791 9.75 20.582V17.332Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M8.6665 13.0013H2.1665V7.58464C2.1665 6.38755 3.13609 5.41797 4.33317 5.41797H6.49984C7.69692 5.41797 8.6665 6.38755 8.6665 7.58464V13.0013Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1665 13H8.6665V20.5833C8.6665 21.7804 7.69692 22.75 6.49984 22.75H4.33317C3.13609 22.75 2.1665 21.7804 2.1665 20.5833V13Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyProfitsIcon);
export default __webpack_public_path__ + "static/media/monthly-profits-icon.7ec3b283b6121d6ea0bca943800a9342.svg";
export { ForwardRef as ReactComponent };